// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { BitMaskMessage, BitMaskMessageT } from './bit-mask-message';
import { EncodedMessageContent, unionToEncodedMessageContent, unionListToEncodedMessageContent } from './encoded-message-content';
import { OneHotMessage, OneHotMessageT } from './one-hot-message';


export class Message implements flatbuffers.IUnpackableObject<MessageT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):Message {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsMessage(bb:flatbuffers.ByteBuffer, obj?:Message):Message {
  return (obj || new Message()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsMessage(bb:flatbuffers.ByteBuffer, obj?:Message):Message {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new Message()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

contentType():EncodedMessageContent {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint8(this.bb_pos + offset) : EncodedMessageContent.NONE;
}

content<T extends flatbuffers.Table>(obj:any):any|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null;
}

static startMessage(builder:flatbuffers.Builder) {
  builder.startObject(2);
}

static addContentType(builder:flatbuffers.Builder, contentType:EncodedMessageContent) {
  builder.addFieldInt8(0, contentType, EncodedMessageContent.NONE);
}

static addContent(builder:flatbuffers.Builder, contentOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, contentOffset, 0);
}

static endMessage(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  builder.requiredField(offset, 6) // content
  return offset;
}

static createMessage(builder:flatbuffers.Builder, contentType:EncodedMessageContent, contentOffset:flatbuffers.Offset):flatbuffers.Offset {
  Message.startMessage(builder);
  Message.addContentType(builder, contentType);
  Message.addContent(builder, contentOffset);
  return Message.endMessage(builder);
}

unpack(): MessageT {
  return new MessageT(
    this.contentType(),
    (() => {
      const temp = unionToEncodedMessageContent(this.contentType(), this.content.bind(this));
      if(temp === null) { return null; }
      return temp.unpack()
  })()
  );
}


unpackTo(_o: MessageT): void {
  _o.contentType = this.contentType();
  _o.content = (() => {
      const temp = unionToEncodedMessageContent(this.contentType(), this.content.bind(this));
      if(temp === null) { return null; }
      return temp.unpack()
  })();
}
}

export class MessageT implements flatbuffers.IGeneratedObject {
constructor(
  public contentType: EncodedMessageContent = EncodedMessageContent.NONE,
  public content: BitMaskMessageT|OneHotMessageT|null = null
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  const content = builder.createObjectOffset(this.content);

  return Message.createMessage(builder,
    this.contentType,
    content
  );
}
}
